const TournamentTeamsTypes = {
    GET_TOURNAMENT_TEAMS_START:'GET_TOURNAMENT_TEAMS_START',
    GET_TOURNAMENT_TEAMS_SUCCESS:'GET_TOURNAMENT_TEAMS_SUCCESS',
    GET_TOURNAMENT_TEAMS_FAILED:'GET_TOURNAMENT_TEAMS_FAILED',

}

export default TournamentTeamsTypes